'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useColors } from 'pdp/src/contexts/ColorsProvider/ColorsProvider'
import { useProduct } from 'pdp/src/contexts/ProductProvider/ProductProvider'
import { env } from 'utils/envManager'
import { ClientLink } from 'utils/link/client'

export function ConformityDeclaration(): React.ReactNode {
	const {
		country: { countryISO, languageISO, legal },
	} = useMasterData()
	const { t } = useLabels()
	const { selectedColor } = useColors()
	const { product } = useProduct()

	if (
		!legal?.conformityCertificate ||
		!selectedColor.legal?.conformityCertificate
	) {
		return null
	}

	const url = new URL(
		`/${countryISO.toLowerCase()}/${languageISO.toLowerCase()}/conformity-declaration?productId=${product.id}&colorId=${selectedColor.id}`,
		env.NEXT_PUBLIC_SITE_BASE_URL
	).href

	return (
		<ClientLink
			href={url}
			linkProps={{ target: '_blank', rel: 'noopener noreferrer' }}
		>
			{t('pdp.declarationOfConfirmity.link')}
		</ClientLink>
	)
}
